import { useEffect, useMemo, useState } from 'react'
import { MajorityCropsResponse } from './types'
import { HistogramLegend } from '../useHistogramLegend'
import { FeatureCollection } from 'geojson'

export const useMajorityCrops = (geometry: FeatureCollection, year: number) => {
  const [data, setData] = useState<null | HistogramLegend>()

  const worker: Worker = useMemo(
    () => new Worker(new URL('./majorityCropsWorker.ts', import.meta.url), { type: 'module' }),
    []
  )

  useEffect(() => {
    if (window.Worker) {
      worker.onmessage = ({ data }: MessageEvent<MajorityCropsResponse>) => {
        switch (data.type) {
          case 'majorityCrops':
            setData(data.majorityCrops)
            break
        }
      }
    }
  }, [worker])

  useEffect(() => {
    if (geometry?.features?.length && year) {
      worker?.postMessage({ type: 'getMajorityCrops', geometry, year })
    } else {
      setData(null)
    }
  }, [geometry, year])

  return data
}
